import React, { useEffect, useState } from "react";
import SelectField from "../../ReusableComponents/SelectField";
import Form from "../../ReusableComponents/Form";
import { Button } from "../../Components/Helper";
import { getTalukaAndDistrict } from "../../apis/BhuMeetTeams/Crm/leads";
import { getTalukaAndDistrict as DspTalukaAndDistrict } from "../../apis/users";
import { useSelector } from "react-redux";
import { ReactComponent as Vector } from "../../assets/Vector.svg"
import Popup from "../../ReusableFunctions/Popup";
import { ReactComponent as Arrow } from "../../assets/Arrow 5.svg"



export const ExcelvalueEditor = ({ datas, renamedColumns, onSubmits }) => {

    const user = useSelector(state => state.user?.user)

    const [replacements, setReplacements] = useState({});

    const [currentSelection, setCurrentSelection] = useState({});

    const [data, setData] = useState(datas)

    // Calculate distinct values from data for each column.
    const [distinctValues, setDistinctValues] = useState({});
    const [taluka, setTaluka] = useState({});
    const [district, setDistrict] = useState({});
    const [rawDistrict, setRawDistrict] = useState({})
    const [column, setColumn] = useState()

    useEffect(() => {
        // console.log(data, "data")
        TalukaAndDistrict()


    }, [renamedColumns, data]);




    function updateStateAndDistrictByTaluka(data, talukaMap, col) {
        // console.log(talukaMap)
        return data.map(entry => {
            if (entry[col]) {
                if (entry[col] == talukaMap.previous) {
                    return {
                        ...entry,
                        Taluka: talukaMap.taluka || entry.Taluka,
                        State: talukaMap.state || entry.State,
                        District: talukaMap.district || entry.District
                    };
                }
            }
            return entry; // leave unchanged if no Taluka match
        });
    }

    function updateDistinctValues(data, previous, current, col) {

        return data.map(entry => {
            if (entry[col]) {
                if (entry[col] == previous) {
                    return {
                        ...entry,
                        [col]: current
                    };
                }
            }
            return entry; // leave unchanged if no Taluka match
        });
    }


    const distinctValuesMap = () => {
        const distinct = {};
        const updatedRows = [];

        // console.log("Before", data);

        if (!(data[0]?.State && data[0]?.District && data[0]?.Taluka)) {
            onSubmits(data)
        }

        // Use map to track updated rows
        const newData = data.filter((i) => {
            const original = { ...i };
            let updated = false;

            if (i.Taluka) {
                const getDistrict = getDistrictBytaluka(i.Taluka);
                // console.log(getDistrict)
                if (getDistrict) {
                    const state = findStateAndDistrict(getDistrict)?.state;
                    if (state) {
                        i['State'] = state;
                        updated = true;
                    }

                    if (!i.District) {
                        i.District = getDistrict;
                        updated = true;
                    }
                }
                // updatedRows.push(i);
                // return false;
            }

            if (i.District) {
                const state = findStateAndDistrict(i.District)?.state;
                if (state) {
                    i.State = state;
                    updated = true;
                }
            }

            if (i.State && district[i.State]) {
                updated = true
            }


            if (updated) {

                updatedRows.push(i);
                return false; // exclude this row from data
            }

            return true; // keep unchanged rows
        });

        renamedColumns.forEach((col) => {
            const values = newData.map((row) => row[col]).filter(Boolean);
            distinct[col] = [...new Set(values)];
        });
        console.log(distinct)
        setDistinctValues(distinct);

        // If you want to use `updatedRows` later, you can store it in a state or global variable
        // Example: setUpdatedRows(updatedRows);
    };


    const TalukaAndDistrict = async () => {
        try {
            let data = user.bhumeet_role ? await getTalukaAndDistrict() : await DspTalukaAndDistrict()
            // console.log(data)
            let taluka = []
            for (let i in data.talukas) {
                for (let j of data.talukas[i].talukas) {
                    taluka.push({ label: j.subdistrict_name_english + " (" + i + ")", value: j.subdistrict_name_english })
                }
            }
            setRawDistrict(data.talukas)
            setDistrict(data.districts)
            setTaluka(taluka)

        } catch (err) {
            console.error(err)
        }
    }

    const findStateAndDistrict = (value, districts = undefined) => {
        let district
        if (!districts) {
            try {
                district = value.split("(")[1].replace(")", "").trim()
            } catch (err) {
                district = value
            }

        }

        let state = getStateByDistrict(district || value)
        return { district, state }
    }

    function getStateByDistrict(districtName) {
        for (const [state, info] of Object.entries(district)) {
            if (info.districts.some(d => d.district_name_english === districtName)) {
                return state;
            }
        }
        return null; // Not found
    }

    function getDistrictBytaluka(TalukaName) {
        // console.log(rawDistrict)
        for (const [state, info] of Object.entries(rawDistrict)) {
            if (info.talukas.some(d => d.subdistrict_name_english === TalukaName)) {
                return state;
            }
        }
        return null; // Not found
    }

    // When dropdown value changes for a column.
    const handleSelectChange = async (col, selected, type = 'from') => {
        console.log(col, selected, type)
        if (type == 'to' && col == 'Taluka') {
            const { district, state } = findStateAndDistrict(selected.label, false)


            setCurrentSelection((prev) => ({
                ...prev,
                [col]: {
                    ...prev[col],
                    [type]: selected.value
                },
                'District': {
                    ...prev['District'],
                    [type]: district
                },
                'State': {
                    ...prev['State'],
                    [type]: state
                }
            }));
        } else if (type == 'to' && col == 'District') {
            const { district, state } = findStateAndDistrict(selected.label, true)
            setCurrentSelection((prev) => ({
                ...prev,
                [col]: {
                    ...prev[col],
                    [type]: selected.value
                },
                'State': {
                    ...prev['State'],
                    [type]: state
                }
            }));
        } else if (type == 'to' && col == 'State') {
            // const {district,state} = findStateAndDistrict(selected.label)
            setCurrentSelection((prev) => ({
                ...prev,
                [col]: {
                    ...prev[col],
                    [type]: selected.value
                }
            }));
        }
        else {
            setCurrentSelection((prev) => ({
                ...prev,
                [col]: {
                    ...prev[col],
                    [type]: selected.value
                }
            }));
        }

    };

    useEffect(() => {
        // console.log(data)
        distinctValuesMap()
    }, [rawDistrict])


    useEffect(() => { console.log(currentSelection) }, [currentSelection])


    // When input field changes for a column.
    const handleInputChange = (col, event) => {
        const value = event.value || event.target.value;
        setCurrentSelection((prev) => ({
            ...prev,
            [col]: {
                ...prev[col],
                to: value
            }
        }));
    };

    const handleReplace = async (col) => {
        const current = currentSelection[col] || {};

        // console.log(current)
        if (!current.from || !current.to) return;

        let state, district;

        switch (col) {
            case 'Taluka':
                district = getDistrictBytaluka(current.to);
                state = findStateAndDistrict(district).state;
                break;
            case 'District':
                ({ district, state } = findStateAndDistrict(current.to));
                break;
        }

        if (col == 'Taluka' || col == 'District' || col == 'State') {

            const updated = await updateStateAndDistrictByTaluka(
                data,
                {
                    previous: current.from,
                    current: current.to,
                    district: district,
                    state: col === 'State' ? current.to : state,
                    taluka: currentSelection?.Taluka?.to || ''
                },
                col
            );


            setData(updated);
        } else {
            const updatevalue = await updateDistinctValues(data, current.from, current.to, col)
            setData(updatevalue);

        }



        distinctValuesMap();

        setReplacements((prev) => ({
            ...prev,
            [col]: {
                ...prev[col],
                [current.from]: current.to,
            },
        }));

        setCurrentSelection((prev) => ({
            ...prev,
            [col]: {
                ...prev[col],
                from: ''
            }
        }));

    };

    // When the form is submitted.
    const handleSubmit = (e) => {
        // e.preventDefault();
        // console.log(data)
        if (onSubmits) onSubmits(data.map(entry =>
            Object.fromEntries(
                Object.entries(entry).filter(([_, value]) => value !== undefined)
            )));

    };

    const showAllGood =
        (!distinctValues['State'] || distinctValues['State'].length === 0) &&
        (!distinctValues['District'] || distinctValues['District'].length === 0) &&
        (!distinctValues['Taluka'] || distinctValues['Taluka'].length === 0);


    useEffect(() => {
        console.log(distinctValues)
        console.log((distinctValues['State'] && distinctValues['State'].length === 0) &&
            (distinctValues['District'] && distinctValues['District'].length === 0 ? true : false) &&
            (distinctValues['Taluka'] && distinctValues['Taluka'].length === 0 ? true : false))
        if (((distinctValues['State'] && distinctValues['State'].length === 0) && !distinctValues['District'] && !distinctValues['Taluka']) ||
            (distinctValues['District'] && distinctValues['District'].length === 0 ? true : false) ||
            (distinctValues['Taluka'] && distinctValues['Taluka'].length === 0 ? true : false)) {
            return handleSubmit()
        }
    }, [distinctValues])

    return (
        <Form onSubmitForm={handleSubmit}>
            {(onSubmitForm) => (
                <div style={{ padding: "16px", display: "flex", flexDirection: "column", gap: "20px" }}>
                    {showAllGood ? (
                        <>
                            <div style={{ fontWeight: "bold", marginBottom: "8px" }}>State / District / Taluka</div>
                            {replacements[column] && (
                                        <div style={{ marginLeft: "16px", fontSize: "13px" }}>
                                            {/* <strong>Replacements:</strong> */}
                                            <ul>
                                                {Object.entries(replacements[column]).map(([from, to]) => (
                                                    <li key={from}>
                                                        {from} → {to}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                        </>
                    ) : <>

                        {renamedColumns
                            .filter((col) => {
                                if (!['State', 'Taluka', 'District'].includes(col)) return false;

                                if (distinctValues['Taluka']?.length > 0) {
                                    return col === 'Taluka'; // Show only Taluka
                                } else if (distinctValues['District']?.length > 0 && (!distinctValues['Taluka'] || distinctValues['Taluka'].length === 0)) {
                                    return col === 'District'; // Show only District
                                } else if (distinctValues['State']?.length > 0 && (!distinctValues['District'] && !distinctValues['Taluka'])) {
                                    return col === 'State'; // Show all if neither condition met
                                }
                            })
                            .map((col) => (
                                <div key={col}>
                                    {/* Column header */}
                                    {setColumn(col)}
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
                                        {/* Dropdown for "Replace From" */}
                                        <div style={{ flex: 1 }}>
                                            <SelectField
                                                name={col}
                                                value={
                                                    currentSelection[col]?.from
                                                        ? { label: currentSelection[col].from, value: currentSelection[col].from }
                                                        : null
                                                }
                                                label={col}
                                                placeholderText={"Select "+ col}
                                                list={(distinctValues[col] || []).map((val) => ({ label: val, value: val }))}
                                                handleChange={(selected) => handleSelectChange(col, selected, 'from')}
                                                isSearchable
                                                styles={{ width: "100%", fontSize: "13px" }}
                                                containerStyle={{ width: "100%", minHeight: "40px" }}
                                            />
                                        </div>

                                        <Arrow style={{marginTop:"20px"}} />

                                        {/* Input or dropdown for "Replace To" */}
                                        {['Taluka', 'State', 'District'].includes(col) ? (
                                            <SelectField
                                                name={col + 1}
                                                value={currentSelection[col]?.from && currentSelection[col]?.to
                                                    ? { label: currentSelection[col].to, value: currentSelection[col].to }
                                                    : null}
                                                label={"Replace with"}
                                                placeholderText={"Select "+ col}

                                                list={
                                                    col === 'Taluka'
                                                        ? taluka
                                                        : col === 'District'
                                                            ? Object.entries(rawDistrict).map(([key]) => ({ label: key, value: key }))
                                                            : Object.entries(district).map(([key]) => ({ label: key, value: key }))
                                                }
                                                handleChange={(selected) => handleSelectChange(col, selected, 'to')}
                                                isSearchable
                                                styles={{ width: "45%", fontSize: "13px" }}
                                                containerStyle={{ width: "45%", minHeight: "40px" }}
                                            />
                                        ) : (
                                            <div style={{ flex: 1 }}>
                                                <input
                                                    type="text"
                                                    placeholder="Replace with..."
                                                    value={currentSelection[col]?.to || ""}
                                                    onChange={(e) => handleInputChange(col, e)}
                                                    style={{
                                                        width: "100%",
                                                        padding: "8px",
                                                        fontSize: "13px",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "4px",
                                                    }}
                                                />
                                            </div>
                                        )}

                                        {/* Replace button */}

                                    </div>
                                    {
                                        <>
                                            <div style={{ display: "flex", gap: "5px" }}>
                                                <Vector /> <span style={{
                                                    color: "#0F5EFF", fontFamily: "Manrope",
                                                    fontWeight: 500,
                                                    fontSize: "14px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0%",
                                                }}> We found {distinctValues[col].length} {col} that do not match , map with correct {col}</span>
                                            </div>
                                        </>
                                    }
                                    {/* Replacements */}
                                    {replacements[col] && (
                                        <div style={{ marginLeft: "16px", fontSize: "13px" }}>
                                            {/* <strong>Replacements:</strong> */}
                                            <ul>
                                                {Object.entries(replacements[col]).map(([from, to]) => (
                                                    <li key={from}>
                                                        {from} → {to}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            ))}
                    </>}



                    {/* Submit button */}
                    {/* <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button
                            isDisabled={distinctValues['Taluka']?.length > 0 || distinctValues['District']?.length > 0 || distinctValues['State']?.length > 0}
                            text="Next"
                            onClick={onSubmitForm}
                            style={{ whiteSpace: "nowrap", height: "30px", marginBottom: "10px", marginRight: "5px" }}
                            className="btn-large"
                        />
                    </div> */}
                    <div style={{display:"flex",justifyContent:"space-between"}}>
                        <div></div>
                        <div>
                            <Button
                                text="Replace"
                                isDisabled={!currentSelection[column]?.from && !currentSelection[column]?.to}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleReplace(column);
                                }}
                                style={{ height: "30px", whiteSpace: "nowrap",width:"80px" }}
                            />
                        </div>
                    </div>
                </div>
            )}
        </Form>
    );
};
